// Kast brand mark — a geometric "K" whose arm fans out from a single pivot into
// two broadcast rays: one source, every platform. Replaces the flat letter-in-a-box.
export function Logo({ size = 40, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      className={className}
      role="img"
      aria-label="Kast logo"
    >
      <defs>
        <linearGradient id="kastGrad" x1="4" y1="2" x2="36" y2="38" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A78BFA" />
          <stop offset="1" stopColor="#6D28D9" />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="11" fill="url(#kastGrad)" />
      {/* spine */}
      <rect x="11.5" y="10" width="4" height="20" rx="2" fill="white" />
      {/* broadcast rays = the K's arm, fanning from one pivot (multistream) */}
      <path d="M15.5 20 L28 10.5" stroke="white" strokeWidth="4" strokeLinecap="round" />
      <path d="M15.5 20 L28 29.5" stroke="white" strokeWidth="4" strokeLinecap="round" />
    </svg>
  )
}
